import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import useStyles from './styles';
import { useWriters } from '../../hooks/context/useWriters.hook';

export const WrittenBy = ({ writtenBy }) => {
  const [writers] = useWriters();
  const classes = useStyles();
  const getWriterInfo = (writerId) => writers.find((writer) => writer.id === writerId);
  return (
    <Grid item xs={12}>
      <InputLabel shrink color="primary" className={classes.textField}>Written by</InputLabel>
      { getWriterInfo(writtenBy) ? getWriterInfo(writtenBy).name : ''}
    </Grid>
  );
};
